import { render, staticRenderFns } from "./Edit_news.vue?vue&type=template&id=14edcc42&scoped=true&"
import script from "./Edit_news.vue?vue&type=script&lang=js&"
export * from "./Edit_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14edcc42",
  null
  
)

export default component.exports